import { Avatar as CommonAvatar } from "@chakra-ui/react"
import * as React from "react"
import { UserAvatarProps } from "./user-avatar.interface"
import { Avatar } from "../../views/home/AvatarsModal/Avatar"
import { convertСonfig } from "../../views/home/AvatarsModal/utils"
import useAuthedUser from "src/hooks/useAuthedUser"

const _UserAvatar: React.FC<UserAvatarProps> = ({
  name,
  size,
  src,
  avatar,
  colorDisk,
  avatarStyle,
  ...props
}) => {
  const {authedUser, getAuthedUser} = useAuthedUser()
  React.useEffect(() => {
    getAuthedUser()
  }, [])
  if (authedUser?.personaImageUrl && !avatar) {
    return (
      <CommonAvatar
        size={size}
        src={authedUser.personaImageUrl}
        bg={"transparent"}
        color="white"
        {...props}
      />
    )
  }
  if (
    avatar !== "" &&
    avatar !== undefined &&
    avatar !== null &&
    !avatar.startsWith("http")
  ) {
    const config = convertСonfig(avatar)
    return <Avatar {...config} style={avatarStyle} />
  } else if (
    avatar !== "" &&
    avatar !== undefined &&
    avatar !== null &&
    avatar.startsWith("http")
  ) {
    return (
      <CommonAvatar
        name={src ? " " : name}
        size={size}
        src={src}
        bg={"transparent"}
        color="white"
        {...props}
      />
    )
  } else {
    return (
      <CommonAvatar
        name={name}
        size={size}
        src={src}
        bg={colorDisk}
        color="white"
        {...props}
      />
    )
  }
}

export const UserAvatar = React.memo(_UserAvatar)
